import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '伦理剧', to: '/category/ethics' },
  { label: '最新', to: '/category/latest' },
  { label: '经典', to: '/category/classic' },
  { label: '搜索', to: '/search' },
  { label: '关于', to: '/about' },
  { label: '联系', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold tracking-wide text-background-50">
                伦理片在线观看
              </span>
            </div>
            <p className="text-sm leading-7 text-background-300 max-w-lg">
              一个专注伦理题材影视剧的内容门户。我们整理剧集信息、主创班底与剧情梗概，帮助你在众多作品中更快找到想看的故事。站内内容均为演示数据，仅用于浏览与阅读。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <span className="text-xs tracking-widest text-background-400 uppercase">Follow</span>
              <div className="flex items-center gap-2">
                {['wx', 'wb', 'dy'].map((key) => (
                  <span
                    key={key}
                    className="w-8 h-8 rounded-full border border-background-700 flex items-center justify-center text-background-300 text-xs"
                  >
                    {key === 'wx' ? '微' : key === 'wb' ? '博' : '抖'}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/category/ethics" className="hover:text-accent-400 transition-colors">
                  伦理剧集
                </Link>
              </li>
              <li>
                <Link to="/category/latest" className="hover:text-accent-400 transition-colors">
                  最新上线
                </Link>
              </li>
              <li>
                <Link to="/category/classic" className="hover:text-accent-400 transition-colors">
                  经典佳作
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-accent-400 transition-colors">
                  剧集搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">关于本站</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">
                  平台介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">
                  内容版权声明
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-accent-400 transition-colors">
                  合作与联系
                </Link>
              </li>
              <li>
                <span className="text-background-500">内容均为演示数据</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 伦理片在线观看 · 本站为影视内容展示与信息浏览平台，数据为站内演示内容
          </p>
          <p className="text-xs text-background-400">
            内容仅供阅读参考 · 请通过正规渠道观看影视作品
          </p>
        </div>
      </div>
    </footer>
  );
}

export function Breadcrumb({ items }: { items: { label: string; to?: string }[] }) {
  const location = useLocation();
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
      {items.map((item, idx) => (
        <span key={item.label} className="flex items-center gap-1.5">
          {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {item.to ? (
            <Link
              to={item.to}
              className={`transition-colors hover:text-primary-600 ${location.pathname === item.to ? 'text-foreground-700' : ''}`}
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export { navItems };